import { Controller } from "@hotwired/stimulus"
import { Natural } from "@ecodev/natural-gallery-js"
import "@ecodev/natural-gallery-js/natural-gallery.css"
// import "@ecodev/natural-gallery-js/themes/natural.css" // Theme not found in root, commenting out for now

export default class extends Controller {
    static values = {
        photos: Array,
        url: String
    }

    connect() {
        console.log("Gallery controller connected")

        // Create specific element for gallery
        this.element.innerHTML = ""
        const galleryElement = document.createElement('div')
        this.element.appendChild(galleryElement)

        // Transform initial photos
        const items = this.photosValue.map(photo => this.transformPhoto(photo))

        // Initialize Natural Gallery
        const options = {
            rowHeight: 350, // Slightly larger for better view
            gap: 5,
            lightbox: true,
            infiniteScrollOffset: 0 // Trigger before reaching bottom
        }

        this.loadedPages = new Set()
        this.gallery = new Natural(galleryElement, options, null)

        // Listen for pagination events
        galleryElement.addEventListener('pagination', (event) => {
            console.log("Pagination event:", event.detail)
            this.loadMore(event.detail)
        })

        this.gallery.addItems(items)
    }

    transformPhoto(photo) {
        return {
            thumbnailSrc: photo.thumbnailSrc || photo.src,
            enlargedSrc: photo.enlargedSrc || photo.src,
            enlargedWidth: photo.enlargedWidth || photo.width || 800,
            enlargedHeight: photo.enlargedHeight || photo.height || 600,
            title: photo.title,
            color: photo.color
        }
    }

    async loadMore({ offset, limit }) {
        if (!this.hasUrlValue) return

        // Check for offset 0 (initial load)
        if (offset === 0) return

        const key = `${offset}-${limit}`
        if (this.loadedPages.has(key)) return
        this.loadedPages.add(key)

        console.log(`Loading photos: offset=${offset} limit=${limit}`)

        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set('offset', offset)
        url.searchParams.set('limit', limit)

        try {
            const response = await fetch(url.toString(), {
                headers: {
                    'Accept': 'application/json'
                }
            })

            if (response.ok) {
                const photos = await response.json()
                const items = photos.map(photo => this.transformPhoto(photo))
                this.gallery.addItems(items)
            } else {
                console.error("Failed to load more photos")
            }
        } catch (error) {
            console.error("Error loading photos:", error)
        }
    }

    disconnect() {
        if (this.gallery) {
            this.element.innerHTML = ""
        }
    }
}
